const footerLinks = [
  { title: "内容导航", links: ["首页", "漫画分类", "今日更新", "热门连载", "脑洞专题"] },
  { title: "读者服务", links: ["常见问题", "读者口碑", "关于我们", "联系我们", "脑洞投稿"] },
  { title: "追更专区", links: ["恶搞反转", "神展开", "脑洞大开", "魔性沙雕", "爆笑日常"] },
];

const hrefOf = (label: string) =>
  ({
    首页: "#home",
    漫画分类: "#categories",
    今日更新: "#updates",
    热门连载: "#hot",
    脑洞专题: "#featured",
    常见问题: "#faq",
    读者口碑: "#reviews",
    关于我们: "#contact",
    联系我们: "#contact",
    脑洞投稿: "#contact",
    恶搞反转: "#updates",
    神展开: "#updates",
    脑洞大开: "#updates",
    魔性沙雕: "#updates",
    爆笑日常: "#updates",
  }[label] || "#");

export default function Footer() {
  return (
    <footer className="w-full bg-secondary-800 text-background-100">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-12">
          <div className="md:col-span-5">
            <a href="#home" className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-accent-500 text-lg text-foreground-950">
                <i className="ri-sparkling-2-fill"></i>
              </span>
              <span className="font-heading text-2xl text-background-50">歪歪漫画</span>
            </a>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-background-200">
              专注韩国恶搞反转漫画的内容门户，神展开脑洞、魔性爆笑每日更新。反转剧情在线追更，专治无聊。
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              {["恶搞反转", "神展开", "脑洞", "魔性爆笑"].map((t) => (
                <span key={t} className="rounded-full border border-background-200/30 px-3 py-1 text-xs text-background-200">
                  #{t}
                </span>
              ))}
            </div>
          </div>

          {footerLinks.map((col) => (
            <nav key={col.title} className="md:col-span-2">
              <h4 className="text-sm font-bold text-background-50">{col.title}</h4>
              <ul className="mt-3 space-y-2">
                {col.links.map((l) => (
                  <li key={l}>
                    <a
                      href={hrefOf(l)}
                      className="text-sm text-background-200 transition-colors hover:text-accent-300"
                    >
                      {l}
                    </a>
                  </li>
                ))}
              </ul>
            </nav>
          ))}

          <div className="md:col-span-1"></div>
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-4 border-t border-background-200/20 pt-6 sm:flex-row">
          <p className="text-xs text-background-200">
            © {new Date().getFullYear()} 韩国歪歪漫画 · 恶搞反转 · 脑洞魔性爆笑追更入口
          </p>
          <p className="text-xs text-background-300">
            合作 / 投稿：hello@wayway-manhua.com
          </p>
        </div>
      </div>
    </footer>
  );
}